import { useCallback, useEffect, useRef, useState } from 'react';

function PreloadImages({ images }: { images: Array<string> }) {
  const imageElRef = useRef(new Image());
  const [processing, setProcessing] = useState(false);
  const preloadedRef = useRef([]);
  const queueRef = useRef([]);

  const processingIndexRef = useRef(-1);

  const loadNextImage = useCallback(() => {
    const nextIndex = processingIndexRef.current + 1;
    const nextImage = queueRef.current[nextIndex];

    if (nextImage) {
      imageElRef.current.src = nextImage;
      preloadedRef.current.push(nextImage);
      processingIndexRef.current = nextIndex;
    } else {
      setProcessing(false);
    }
  }, []);

  useEffect(() => {
    queueRef.current = images.filter(
      (it) => preloadedRef.current.indexOf(it) === -1
    );
    processingIndexRef.current = -1;

    if (queueRef.current.length && !processing) {
      loadNextImage();
      setProcessing(true);
    }
  }, [images, loadNextImage, processing]);

  imageElRef.current.onload = loadNextImage;
  imageElRef.current.onerror = loadNextImage;

  return null;
}

export default PreloadImages;
